import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-masterplan',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl overflow-hidden antialiased p-0"
    >
      <div class="flex items-center justify-between px-6 py-5 border-b border-border-subtle">
        <div class="flex items-center gap-2">
          <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
          <h2 class="text-sm font-black text-text-primary uppercase tracking-wider font-mono">
            {{ 'projectsDetails.masterplanTitle' | translate }}
          </h2>
        </div>

        <div
          class="flex items-center gap-1.5 px-2.5 py-1 bg-surface-elevated border border-border rounded-lg text-[10px] font-mono font-bold text-text-muted"
        >
          <i class="fa-solid fa-vector-square text-primary"></i>
          <span>{{ 'projectsDetails.scale' | translate }}</span>
        </div>
      </div>

      <div class="relative group overflow-hidden bg-bg-secondary aspect-[16/10] w-full cursor-zoom-in">
        <img
          [src]="masterplanImage"
          [alt]="'projectsDetails.masterplanAlt' | translate"
          class="w-full h-full object-contain md:object-cover group-hover:scale-105 transition-transform duration-700 ease-out antialiased"
        />

        <div
          class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        ></div>

        <div
          class="absolute bottom-4 right-4 flex items-center gap-2 px-3 py-1.5 bg-surface-modal/90 backdrop-blur-md border border-border-strong rounded-xl shadow-lg opacity-80 group-hover:opacity-100 group-hover:-translate-y-0.5 transition-all duration-300"
        >
          <i class="fa-solid fa-maximize text-[10px] text-primary"></i>
          <span class="text-[10px] font-mono font-bold text-text-secondary uppercase tracking-wider"
            >{{ 'projectsDetails.clickToExpand' | translate }}</span
          >
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class MasterplanComponent {
  @Input() masterplanImage: string = '';
}
